import * as Sentry from "@sentry/vue";
import { applyValidationErrorsFromGraphQL, getErrorMessages } from "~/utils/gqlHelpers";
import { toast } from "~/utils/toast";

export function handleError(error, validationErrorsTarget, title = "Fejl - prøv igen eller kontakt supporten") {
  const nullApolloCases = [
    "this.$apollo is null", // firefox message
    "cannot read properties of null (reading 'mutate')", // chromium message
  ];
  const isApolloNullError = nullApolloCases.some((apolloError) => error.message.toLowerCase().includes(apolloError));
  const isBlockedError = error.graphQLErrors?.some((e) => e.message === "blokeret");
  const isNotFoundError = error.graphQLErrors?.some((e) => e.extensions?.code === "NOT_FOUND_ERROR");

  const isNetworkError = Boolean(error.networkError);
  const errorMessages = getErrorMessages(error);

  let validationErrors = {};
  let text;

  applyValidationErrorsFromGraphQL(validationErrors, error);
  const hasValidationErrors = Object.keys(validationErrors).length > 0;

  if (isNetworkError) {
    title = "Netværksfejl - tjek forbindelsen og prøv igen eller kontakt supporten";
    text = error.networkError.result?.error?.message || "";
  }

  if (hasValidationErrors && validationErrorsTarget) {
    // show validation errors in form
    Object.assign(validationErrorsTarget, validationErrors);
  } else if (hasValidationErrors && !validationErrorsTarget) {
    // show toast for validation errors that do not show in form
    Object.keys(validationErrors).forEach((key) => {
      const errors = validationErrors[key];
      if (errors.length) toast.error(title, errors.join(" "));
    });
  } else if (errorMessages.length) {
    // non-validation errors
    errorMessages.forEach((errorMessage) => toast.error(errorMessage));
  } else if (!isApolloNullError) {
    // generic error
    toast.error(title, text);
  }

  if (!hasValidationErrors && !isNetworkError && !isApolloNullError && !isBlockedError && !isNotFoundError) {
    Sentry.captureException(error);
  }

  return {
    isNetworkError,
    hasValidationErrors,
    validationErrors,
  };
}
